import type { TradeReviewDto } from '../../lib/api/endpoints';
import { cn } from '../../lib/utils';

export function ReviewsList({
  reviews,
  selectedTradeId,
  onSelect,
}: {
  reviews: TradeReviewDto[];
  selectedTradeId: string | null;
  onSelect: (tradeId: string) => void;
}) {
  if (reviews.length === 0) {
    return <p className="p-4 text-sm text-text-muted">No reviews in this view.</p>;
  }

  return (
    <ul className="divide-y divide-border">
      {reviews.map((review) => (
        <li key={`${review.id}-${review.tradeId}`}>
          <button
            type="button"
            className={cn(
              'grid w-full gap-2 px-4 py-3 text-left hover:bg-surface-raised',
              selectedTradeId === review.tradeId ? 'bg-surface-raised' : 'bg-surface',
            )}
            onClick={() => onSelect(review.tradeId)}
          >
            <span className="flex items-center justify-between gap-3">
              <span className="font-semibold">{review.symbol}</span>
              {review.reviewMode ? (
                <span className="rounded border border-border px-2 py-0.5 text-xs uppercase text-text-muted">
                  {review.reviewMode}
                </span>
              ) : null}
            </span>
            <span className="grid grid-cols-2 gap-2 text-xs text-text-muted sm:grid-cols-4">
              <span>{review.side}</span>
              <span className={Number(review.realisedPnl) >= 0 ? 'text-success' : 'text-danger'}>
                {Number(review.realisedPnl).toLocaleString(undefined, {
                  style: 'currency',
                  currency: 'USD',
                })}
              </span>
              <span>{new Date(review.closedAt).toLocaleDateString()}</span>
              <span>{Math.max(0, Math.floor(review.ageHours / 24))}d ago</span>
            </span>
          </button>
        </li>
      ))}
    </ul>
  );
}
